import axios from 'axios'

if (location.host === 'localhost:8099') {
  axios.defaults.baseURL = '/api'
} else {
  axios.defaults.baseURL = '/'
}
axios.defaults.timeout = 50000
axios.defaults.withCredentials = true

//全局拦截请求，如果返回未登录状态，直接回退到登录界面，提示用户重新登录
axios.interceptors.response.use(
  function (response) {
    
    return response
  },
  function (error) {
    let errorMsg = ''
    if (error.response) {
      let status = error.response.data.code
      if (status === 1001) {
        
      }
      if (error.response.status === 500) {
        errorMsg = '请求超时'
      }
    }
    return Promise.reject(errorMsg)
  }
)

/**
 * 根据用户的输入信息，获取领域分类列表
 * param {prologue}
 */
export const getDomains = (params) => {
  return axios.post('/pls/dialog/domain', params)
}

/**
 * 根据用户选择的领域，获取对应的要素
 * param {prologue, domain}
 */
export const getFactors = (params) => {
  return axios.post('/pls/dialog/factor', params)
}

/**
 * 根据用户选择的领域获取回来的要素，获取对应关系图
 * param {prologue, domain, yes, no, ask=1}
 */
export const getGraph = (params) => {
  return axios.post('/pls/dialog/graph', params)
}

/**
 * 根据用户选择的领域获取回来的要素，获取对应的后续问题列表
 * param {prologue, domain, yes, no}
 */
export const getTells = (params) => {
  return axios.post('/pls/dialog/tell', params)
}

/**
 * 根据用户选择的领域获取回来的要素，获取对应的后续具体问题
 * param {prologue, domain, yes, no}
 */
export const getAsk = (params) => {
  return axios.post('/pls/dialog/ask', params)
}

/**
 * 生成报告
 * param {domain, yes, no}
 */
export const createReport = (params) => {
  return axios.post('/pls/dialog/report', params)
}


// WEBPACK FOOTER //
// ./src/api/api.js